An array of short phrases that tell the user what value this advertisement product provides.
